t = require('app/scripts/views/internal/teacup-with-helpers')('member_on_card')
memberTemplate = require('./member')

module.exports = t.renderable ({ avatarHash, fullName, id, initials, isDeactivated, isBoardAdmin, isOrganizationAdmin, isVirtual, username, viewTitle }) ->
  t.div '.member.js-member-on-card-menu', {
    class: t.classify({
      'member-deactivated': isDeactivated,
      'member-virtual': isVirtual,
      'long-initials': initials?.length > 2
    }),
    'data-idmem': id
  }, ->
    memberTemplate({
      avatarHash
      fullName
      initials
      isDeactivated
      isBoardAdmin
      isOrganizationAdmin
      username
      viewTitle
    })
